import * as C from './card-informative-description.styles'

type CardInformativeDescriptionProps = {
  children: React.ReactNode
  testID?: string
}

export const CardInformativeDescription = (
  props: CardInformativeDescriptionProps
) => {
  const { children, testID } = props
  const descriptionProps = {
    numberOfLines: 4,
  }
  return (
    <C.Description {...descriptionProps} testID={testID}>
      {children}
    </C.Description>
  )
}
